import { StripePrice } from '../types'
import localizeCurrency from './localizeCurrency'

export default function localizeStripePrice({
  fraction = 1,
  stripePrice,
  userCurrency,
}: {
  fraction?: number
  stripePrice: StripePrice | undefined
  userCurrency: string | undefined
}): string | undefined {
  if (!stripePrice || !userCurrency) return undefined

  const { stripePriceAmountInCents, stripePriceCurrency } =
    getStripePriceAmountAndCurrency({ stripePrice, userCurrency })

  if (!stripePriceAmountInCents || !stripePriceCurrency) return undefined

  return localizeCurrency({
    amountInCents: stripePriceAmountInCents / fraction,
    currency: stripePriceCurrency,
  })
}

export function getStripePriceAmountAndCurrency({
  stripePrice,
  userCurrency,
}: {
  stripePrice: StripePrice
  userCurrency: string
}): {
  stripePriceAmountInCents: number
  stripePriceCurrency: string
} {
  const hasCurrencyOption =
    !!stripePrice.currency_options?.[userCurrency]?.unit_amount_decimal

  const amountInCents = parseFloat(
    hasCurrencyOption
      ? stripePrice.currency_options[userCurrency].unit_amount_decimal
      : stripePrice.unit_amount_decimal,
  )

  const currency = hasCurrencyOption ? userCurrency : stripePrice.currency

  return {
    stripePriceAmountInCents: amountInCents,
    stripePriceCurrency: currency,
  }
}
